import Chart from 'chart.js/auto';

import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

import React, { useState, useEffect } from 'react'

import BranchStore from '../../store/slice/branch.slice'

import doUtility from '../utility'

import { MiniLoader } from '../utility/componentUtility'

import { useNavigate, useLocation  } from 'react-router-dom'

import { Col, Row, Typography, Button, Table, Collapse } from 'antd'

import { DownloadOutlined } from '@ant-design/icons';

const { Title } = Typography

const { Panel } = Collapse;

function DBranchDetails () {
    const navigate =  useNavigate()

    const location = useLocation();
    const BranchCode = location.state.SeletedBranch;

    localStorage.setItem("brCode", BranchCode.BRANCH_KEY)
    localStorage.setItem("brName", BranchCode.BRANCH_NAME)
    localStorage.setItem("brBusinessType", BranchCode.LINE_OF_BUSINESS)

    const [loading, setLoading]             = useState(false)

    const BranchPolSumry = BranchStore((state) => state.BranchPolSumry)

    const BranchStrength = BranchStore((state) => state.BranchStrength)

    const getBranchStrength = BranchStore((state) => state.getBranchStrength)
    const getBranchPolSumry = BranchStore((state) => state.getBranchPolSumry)

    useEffect(() => {
        if(BranchCode == null){
            navigate('/dashboard/')
        }
        
        getBranchPolSumry(BranchCode.BRANCH_KEY)
        getBranchStrength(BranchCode.BRANCH_KEY)
    
        BranchStore.setState({ BranchCode: BranchCode.BRANCH_KEY })
    }, [BranchCode, navigate, getBranchPolSumry, getBranchStrength])


    const [BranchPolSumryChartData, setBranchPolSumryChartData] = useState({
        datasets: [],
    });

    const [BranchStrengthChartData, setBranchStrengthChartData] = useState({
        datasets: [],
    });
     
    const chartOptions = {
        indexAxis: 'y',
        responsive: true,
        
            maintainAspectRatio: false,
            maxBarThickness: 10,
        
        plugins: {
            legend: {
                position: "top",
            },
            title: {
                display: true,
                text: "",
            },
            datalabels: {
                display: true,
                color: "black",
                formatter: Math.round,
                anchor: "end",
                offset: -2,
                align: "end"
            }
        },
        scales: {
            x: {
              ticks: {
                beginAtZero: true
              }
            },
            y: {
              ticks: {
                autoSkip: false,
                beginAtZero: true,
                stepSize: 1
              }
            }
          }
        /*scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }],
            xAxes: [{
              ticks: {
                
              }
            }]
          }*/
    }

    useEffect(() => {

        if(BranchPolSumry != null && BranchPolSumry !== "loading" ){
            let inBranchPolSumry = BranchPolSumry

            if(!Array.isArray(BranchPolSumry)){
                inBranchPolSumry = [BranchPolSumry]
            }

            setBranchPolSumryChartData({
                labels: inBranchPolSumry.map((data) => data.POLICY_STATUS),
                datasets: [
                    {
                        label: "Branch Policy Summary",
                        data: inBranchPolSumry.map((data) => data.NO_OF_POLICIES),
                        borderColor: "rgb(53, 162, 235)",
                        backgroundColor: "rgb(186, 12, 47)",
                    },
                ],
            })
        }

    }, [BranchPolSumry])

    useEffect(() => {

        if(BranchStrength != null && BranchStrength !== "loading"){

            let inBranchStrength = BranchStrength

            if(!Array.isArray(BranchStrength)){
                inBranchStrength = [BranchStrength]
            }

            setBranchStrengthChartData({
                labels: inBranchStrength.map((data) => data.AGENT_RANK),
                datasets: [
                    {
                        label: "Branch Strength",
                        data: inBranchStrength.map((data) => data.NO_OF_AGENT),
                        borderColor: "rgb(53, 162, 235)",
                        backgroundColor: "rgb(186, 12, 47)",
                    },
                ],
            })
        }

    }, [BranchStrength])


    return(
        <div className='dashboard'>
            <Row className='main-heading'>
                <Col md={24}>
                    <Title level={2}> { BranchCode.BRANCH_NAME }  <span className='font-red'> ( { BranchCode.LINE_OF_BUSINESS } ) </span> </Title>
                </Col>
            </Row>

            <Row className='table-sm-font'>

                <Col md={12} className='p5'>
                   
                    <div className='back-white p5'>
                        <Title className='p10' level={5}> BRANCH POLICY SUMMARY </Title>
                        <div>
                            <Bar options={chartOptions} plugins={[ChartDataLabels]} data={BranchPolSumryChartData} height={500} />
                        </div>
                    </div>

                    <Collapse accordion>
                        <Panel header="DATA" key="1">
                        {( () => {
                            if (BranchPolSumry && BranchPolSumry.length > 0) {
                                if(BranchPolSumry === 'loading'){
                                    return (
                                        <MiniLoader />
                                    )
                                }else{
                                    const dataBranchPolSumry = doUtility.RenderTableData(BranchPolSumry)
                                    const dataBranchPolSumrycolumn = dataBranchPolSumry.column.filter(function(item) {
                                        if(item.dataIndex == 'V_CNTR_STAT_CODE'){
                                            return false
                                        }else{
                                            return true
                                        }
                                    })
                                    return (
                                        <div>
                                            <Button className='p5' style={{float: 'right'}} 
                                                danger icon={<DownloadOutlined />}
                                                onClick={()=> jsonTocsv(JSON.stringify(dataBranchPolSumry.datasource), 'BRANCH POLICY SUMMARY')}>
                                                Export
                                            </Button>
                                            <Table
                                                className='back-white' 
                                                style={{ margin: 'auto', borderRadius: '2px'}} 
                                                dataSource={dataBranchPolSumry.datasource} columns={dataBranchPolSumrycolumn} />
                                        </div>
                                    )
                                }
                            }
                        }) ()}
                        </Panel>
                    </Collapse>
                </Col>

                <Col md={12} className='p5'>
                    
                    <div className='back-white p5'>
                        <Title className='p10' level={5}> BRANCH STRENGTH </Title>
                        <div>
                            <Bar options={chartOptions} plugins={[ChartDataLabels]} data={BranchStrengthChartData} height={500} />
                        </div>
                    </div>

                    <Collapse accordion>
                        <Panel header="DATA" key="1">
                        {( () => {
                            if (BranchStrength && BranchStrength.length > 0) {
                                if(BranchStrength === 'loading'){
                                    return (
                                        <MiniLoader />
                                    )
                                }else{
                                    const dataBranchStrength = doUtility.RenderTableData(BranchStrength)
                                    const dataBranchStrengthcolumn = dataBranchStrength.column.filter(function(item) {
                                        if(item.dataIndex == 'N_LEVEL'){
                                            return false
                                        }else{
                                            return true
                                        }
                                    })
                                    return (
                                        <div>
                                            <Button className='p5' style={{float: 'right'}} 
                                                danger icon={<DownloadOutlined />}
                                                onClick={()=> jsonTocsv(JSON.stringify(dataBranchStrength.datasource), 'BRANCH STRENGTH')}>
                                                Export
                                            </Button>

                                            <Table
                                                className='back-white' 
                                                style={{ margin: 'auto', borderRadius: '2px'}} 
                                                dataSource={dataBranchStrength.datasource} columns={dataBranchStrengthcolumn} />
                                        </div>
                                    )
                                }
                            }
                        }) ()}
                        </Panel>
                    </Collapse>
                </Col>
            
            </Row>
        </div>
    )
}

const jsonTocsv = (objArray, file_name="donwload.csv") => {

    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ','

            line += array[i][index];
        }

        str += line + '\r\n';
    }

    var fs = Object.keys(array[0]).join(',')+ '\r\n' + str;

    let csvContent = `data:text/csv;charset=utf-8,${fs}`
    var encodedUri = encodeURI(csvContent);

    const downloadLink = document.createElement("a")
    downloadLink.href = encodedUri
    downloadLink.setAttribute('download', file_name);
    downloadLink.target = "_blank"
    downloadLink.click()

}

export default DBranchDetails